import { Dialog } from "@headlessui/react"
import { FC, useEffect } from "react"
import * as React from "react"
import Payment from "../../../account/payment/Payment"
import { X } from "heroicons-react"

type AdminPaymentMethodModalProps = {
  open: boolean
  onClose: () => void
  paymentMethodsAdminEntry?: (userId?: number) => void
  userId: number | undefined
  readOnly: boolean
  isModal: boolean
}
const AdminPaymentMethodModal: FC<AdminPaymentMethodModalProps> = (props) => {
  const { onClose, open, readOnly } = props

  useEffect(() => {
    if (!props.userId) {
      return
    }

    if (props.paymentMethodsAdminEntry) {
      props.paymentMethodsAdminEntry(props.userId)
    }

    return () => {
      if (props.userId && props.paymentMethodsAdminEntry) {
        props.paymentMethodsAdminEntry(undefined)
      }
    }
  }, [props.userId])

  const renderMain = () => {
    return (
      <div
        className="bg-white elev-b-sm rounded-lg overflow-hidden"
        style={{
          overflowY: "auto",
          height: props.isModal ? "80vh" : "35vh",
          width: props.isModal ? "100vh" : "80vh",
          padding: props.isModal ? 42 : 22
        }}
      >
        <Payment adminPage={true} readOnly={readOnly} hideTitle={!props.isModal} />
      </div>
    )
  }

  return props.isModal ? (
    <Dialog open={open} onClose={onClose} className="relative">
      <div className="fixed inset-0 bg-[rgba(0,0,0,0.3)]" aria-hidden="true" />
      <div className="fixed inset-0 flex items-center justify-center p-4">
        <div>
          <div className={`flex justify-end`}>
            <X className="h-4 cursor-pointer mt-1" style={{ position: "absolute" }} onClick={onClose} />
          </div>
          {renderMain()}
        </div>
      </div>
    </Dialog>
  ) : (
    renderMain()
  )
}

export default AdminPaymentMethodModal
